import React, { useState, useRef } from 'react';
import '../styles/Chair.css';
import { ChairProps } from '../types';
import { useEnvironment } from '../contexts/EnvironmentContext';

const Chair: React.FC<ChairProps> = ({ chairNumber, isSelected, onClick, occupant, onHover, onLeave }) => {
  const [showPopup, setShowPopup] = useState<boolean>(false);
  const [popupPosition, setPopupPosition] = useState<{ x: number; y: number }>({ x: 0, y: 0 });
  const chairRef = useRef<HTMLDivElement>(null);
  const { config } = useEnvironment();

  const formatChairNumber = (num: number): string => {
    return `A-${num}`;
  };

  const handleMouseEnter = (e: React.MouseEvent<HTMLDivElement>): void => {
    if (occupant && chairRef.current && config.showPopups) {
      const rect = chairRef.current.getBoundingClientRect();
      setPopupPosition({
        x: rect.left + rect.width / 2 - 140, // Center the popup
        y: rect.top - 10 // Position above the chair
      });
      setShowPopup(true);
      onHover && onHover(chairNumber, occupant);
    }
  };

  const handleMouseLeave = (): void => {
    setShowPopup(false);
    onLeave && onLeave(chairNumber);
  };

  const handleMouseMove = (e: React.MouseEvent<HTMLDivElement>): void => {
    if (occupant && showPopup && chairRef.current && config.showPopups) {
      const rect = chairRef.current.getBoundingClientRect();
      setPopupPosition({
        x: rect.left + rect.width / 2 - 140,
        y: rect.top - 10
      });
    }
  };

  return (
    <>
      <div 
        ref={chairRef}
        className={`chair ${isSelected ? 'selected' : ''} ${occupant ? 'occupied' : 'available'} ${occupant?.studentType === 'test' ? 'test-student' : ''}`}
        onClick={() => onClick(chairNumber)}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
        onMouseMove={handleMouseMove}
      >
        <div className="chair-number">{formatChairNumber(chairNumber)}</div>
        <div className="chair-seat"></div>
        <div className="chair-back"></div>
        {occupant && config.showOccupantDetails && (
          <div className="occupant-indicator">
            <div className="occupant-avatar">
              {occupant.name.charAt(0).toUpperCase()}
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default Chair;
